import noodleApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleApi';

type Input = ApiDefinition['/creators/{creatorSlug}/members/{personId}']['DELETE']['params'];
type Output = ApiDefinition['/creators/{creatorSlug}/members/{personId}']['DELETE']['response'];

const deleteMember = async ({ creatorSlug, personId }: Input): Promise<Output> => {
  const data = await noodleApiClient.delete(`/creators/${creatorSlug}/members/${personId}`);
  return data.data as Output;
};

export default deleteMember;
